import React from 'react';
import { Container, Row, Col, Spinner } from 'reactstrap';
import EditBusinessSettingsForm from '../../../components/Form/Tenant/EditBusinessSettingsForm';
import EditBusinessSettingsMedia from 'components/Form/Tenant/EditBusinessSettingsMedia';
import { useDetailQuery } from 'http-client/hooks/useCrud';
import { API_ENDPOINTS } from 'http-client/httpConstants';
// import { TenantSettingsFormValues } from 'components/Types/Tenant/business-settings.type';

const BusinessSettingsPage: React.FC = () => {
  const tenantId = localStorage.getItem('tenantId') || '';

  const { data: settingsData, isLoading } = useDetailQuery<any>(
    tenantId ? API_ENDPOINTS.TENANT.BUSINESS.GET_BY_ID : '',
    {
      tenantId,
    },
  );

  if (isLoading) {
    return (
      <div
        className="page-content d-flex justify-content-center align-items-center"
        style={{ minHeight: '400px' }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  if (!tenantId) {
    return (
      <div className="page-content py-5 text-center">
        <h3>Tenant identifier is missing.</h3>
        <p>Please sign in again or contact support.</p>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-4">
          <Col lg={12} md={12} className="mb-4">
            <EditBusinessSettingsMedia
              id={tenantId}
              name={settingsData?.name || ''}
              logoUrl={settingsData?.logoUrl || 'https://placehold.co/100x100?text=Logo'}
              coverImageUrl={
                settingsData?.coverImageUrl || 'https://placehold.co/800x200?text=Cover+Image'
              }
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col lg={12} md={12} className="mb-4">
            <EditBusinessSettingsForm tenantId={tenantId} settingsData={settingsData} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BusinessSettingsPage;
